import { cn } from "@/lib/utils";

interface LoaderProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

const sizeMap = {
  sm: "w-4 h-4",   // 16px — inline use
  md: "w-9 h-9",   // 36px — page-level loading states
  lg: "w-14 h-14", // 56px — full-screen auth loading
};

export function Loader({ className, size = "md" }: LoaderProps) {
  return (
    <div
      className={cn("loader", sizeMap[size], className)}
      data-testid="loader"
    />
  );
}
